import type { HasMenuId } from '../../types';

export const getMenuIds = <T extends HasMenuId>(items: T[]): string[] =>
	items.map((item) => item.menuId);
